import { FixedIncomeOfferBaseEntity } from '@genial/services';
import { ResponsesFixedIncomeOrderCreateResponse } from '@genial/services/dist/models';
import { FixedIncomeOrderBuyEntity } from '@genial/services/src';
import { Utils } from '@genial/utils';

import { RiskRating } from '../../../../../../../../components/RiskRating';
import { formatDaysRemaining } from '../../../../../../../../store/product/normalizer';
import { FixedIncomeAssetController } from '../../../../../../../BatchTicket/components/DynamicAsset/hooks/products/FixedIncome';
import { notificationChannelsData } from '../../../../../../../Resume/utils';
import { TicketApplicationBaseInfoProps } from '../../components/TicketApplicationSuccessDetails';

export const getFixedIncomeSuccessInfos = (
  offer: FixedIncomeOfferBaseEntity,
  order: FixedIncomeOrderBuyEntity,
  offerController: FixedIncomeAssetController,
  showSendingChannels: boolean,
  hideDateTimeFieldsOnProverOrigin: boolean
): TicketApplicationBaseInfoProps => {
  const orderHash = order.orderHash || order.orderId || '--';
  const orderName = order.orderName;

  const orderNameFormatted = orderName && orderHash ? `${orderName} - ${orderHash}` : '--';

  const orderChannels = notificationChannelsData({ order });

  const hasOrderOrigin = !!order?.interactionChannelAuditDetail as boolean;

  const maturityDateFormatted = offer.maturityDate
    ? Utils.Mask.DateFormat(offer.maturityDate, 'dd/MM/yyyy')
    : '--';
  const daysToMaturity = offer.maturityDate ? formatDaysRemaining(offer.maturityDate) : '';

  const maturityWithDays = `${maturityDateFormatted}${daysToMaturity}`;

  const productDetails = [
    { label: 'Ativo', value: offer.productDisplay || offer.productDisplayNormalized || '--' },
    {
      label: 'Risco',
      value: (
        <RiskRating
          currentRiskRating={Number(offer.riskRatingLevel) || 0}
          tooltip={offer.riskRatingName || ''}
        />
      ),
    },
    {
      label: 'IR',
      value: offer.incomeTaxAmount ? Utils.Mask.Percentage(offer.incomeTaxAmount) : '--',
    },
    {
      label: 'Rentabilidade anual',
      value: offerController.selectedFee?.profitability || offer.profitabilityFormatted || '--',
    },
    { label: 'Vencimento', value: maturityWithDays },
    {
      label: 'Taxa',
      value: offerController.selectedFee?.customerFeeAmountFormatted || '--',
    },
    {
      label: 'Preço unitário',
      value:
        offerController.selectedFee?.customerPuAmountFormatted ||
        Utils.Mask.Money(offer.unitPrice) ||
        '--',
    },
    {
      label: 'Fee',
      value: offerController.selectedFee?.honorariumFee || '--',
    },
    { label: 'Valor aplicado', value: Utils.Mask.Money(order.orderAmount) },
    {
      label: 'Liquido estimado no vencimento',
      value: Utils.Mask.Money(offerController.estimatedNetValueCalculated),
    },
  ];

  const solicitationDate = order.interactionChannelAuditDetail?.interactionChannelDate;

  const channelDetails = [
    {
      label: 'Canal de solicitação',
      value: order.interactionChannelAuditDetail?.interactionChannelOption.channel || '--',
    },
  ];

  if (!hideDateTimeFieldsOnProverOrigin) {
    channelDetails.push(
      {
        label: 'Data de solicitação',
        value: solicitationDate ? Utils.Mask.DateFormat(solicitationDate, 'dd/MM/yyyy') : '',
      },
      {
        label: 'Horário de solicitação',
        value: solicitationDate ? Utils.Mask.DateFormat(solicitationDate, 'HH:mm') : '',
      }
    );
  }

  const orderDetails = [
    { label: 'Nome da ordem', value: orderNameFormatted },
    ...(hasOrderOrigin ? channelDetails : []),
  ];

  if (showSendingChannels) {
    orderDetails.push(
      { label: 'Canal de envio', value: orderChannels || '--' },
      {
        label: 'Hora/data de Envio',
        value: order.orderDate
          ? Utils.Mask.DateFormat(order.orderDate, 'dd/MM/yyyy HH:mm:ss')
          : '--',
      }
    );
  }

  return {
    orderHash,
    productDetails,
    orderDetails,
  };
};

export const updateSuccessInfosToExport = (
  response: ResponsesFixedIncomeOrderCreateResponse,
  offerController: FixedIncomeAssetController
) => {
  const profitabilityToMaturityNormalized = offerController.selectedFee?.profitability || '--';

  return {
    ...response,
    offer: {
      ...response.offer,
      profitabilityToMaturityNormalized,
    },
  };
};
